import { ChangeDetectorRef, HostListener, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { PageviewsettingsService } from 'src/app/services/pageviewsettings.service';
import { ModalService } from 'src/app/services/modal.service';
import { filter } from 'rxjs';
import { TenantService } from '../../services/tenant.service';
import * as Globals from '../../../globals';

declare let analytics: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent {
	isMenuOpen = false;
	isModalOpen = false;
	tenant: TenantService;
	facultyEnabled: boolean;
	logoUrl = '';
	collegemobile: any;
	tenantId: number | undefined;
	tenantName: string = window.location.href.split('/')[3]; // TODO: Deprecate this and use the TenantService instead.
	loadeddata: any;
	affiliateId: any;

	list:{name: string, url: string}[] = [
		{
			name: 'Fan Plans',
			url: 'fan'
		},
		{
			name: 'Student Plans',
			url: 'student'
		},
		{
			name: 'Faculty',
			url: 'shop-faculty-plans'
		},
		{
			name: 'Why Husky Mobile?', // TODO: Replace with placeholder.
			url: 'why'
		},
		{
			name: 'Support',
			url: Globals.URL_INTERCOM_SUPPORT
		},

		{
			name: 'Give Away Page 2',
			url: 'giveawaypage2'
		}

	]

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private settingsService: PageviewsettingsService,
		private modalService: ModalService,
		private cdr: ChangeDetectorRef,
		private tenantService: TenantService,
    ) {
		this.tenant = tenantService;
 		this.facultyEnabled = this.tenant.getFacultyVisibility()

		this.settingsService.getCollegetenantcode(this.tenantName).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings();
		});

      // let collegeName = this.route.snapshot.paramMap.get('collegemobile');
    
      // this.settingsService.getCollegeImages(collegeName!).subscribe(response => {
       
      //   this.logoUrl = response.logo;
      // });
    
      // if (!collegeName) {
      //   this.router.navigateByUrl('landingpage/huskymobile'); // Redirect if no param
      // }

      // this.settingsService.logo$.subscribe(logo => {
      //   this.logoUrl = logo;
      // });

    	this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        	const flag = this.tenant.getFacultyVisibility();
        	if (flag !== this.facultyEnabled) {
          		this.facultyEnabled = flag;
          		this.cdr.detectChanges();
        	}
      	});
    }

	ngOnInit() {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				let currentRoute = this.route;
				while (currentRoute.firstChild) {
					currentRoute = currentRoute.firstChild;
				}

				this.collegemobile = currentRoute.snapshot.paramMap.get('collegemobile') || 'huskymobile';
				let collegeName = this.collegemobile;
				
				this.settingsService.getCollegetenantcode(collegeName).subscribe(data => {
					this.tenantId = parseInt(data.result.id);
				});
			}
		});
	}

    loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });
    }

     
    trackclick(event:any){
		analytics.track(event)
    } 
    openModal() {
		this.modalService.openModal();
		console.log("modal clicked")
  	}

    selectcustomerType(type: string) {
		this.router.navigate([`/${type}`]);
    }

	toggleMenu() {
		this.isMenuOpen = !this.isMenuOpen;
		 this.cdr.detectChanges();
  	}

	isExternal(url: string): boolean {
		return url.startsWith('http://') || url.startsWith('https://');
	}

 @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.isMenuOpen) {
      this.isMenuOpen = false;
    }
  }

}
